<section class="max-w-5xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
    <div class="bg-white rounded-3xl shadow-sm border border-zinc-200 p-6 sm:p-8 lg:p-12">
        <div class="mb-10 text-center">
            <h1 class="text-3xl sm:text-4xl font-bold text-zinc-900 mb-4 leading-tight">
                {{ 'agreementTerms.header.title' | translate }}
            </h1>
            <div class="w-24 h-1 bg-black mx-auto rounded-full"></div>
            <p class="mt-4 text-zinc-600">{{ 'agreementTerms.header.subtitle' | translate }}</p>
        </div>

        <div class="space-y-8 text-zinc-700 text-[15px] sm:text-base leading-8">
            <p class="text-lg leading-9 text-zinc-600">{{ 'agreementTerms.intro' | translate }}</p>

            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black">
                    {{ 'agreementTerms.registration.title' | translate }}
                </h2>
                <p>{{ 'agreementTerms.registration.p1' | translate }}</p>
            </div>

            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black">
                    {{ 'agreementTerms.publishing.title' | translate }}
                </h2>
                <div class="space-y-4">
                    <p>{{ 'agreementTerms.publishing.p1' | translate }}</p>
                    <p>{{ 'agreementTerms.publishing.p2' | translate }}</p>
                    <p>{{ 'agreementTerms.publishing.p3' | translate }}</p>
                </div>
            </div>

            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black">
                    {{ 'agreementTerms.payments.title' | translate }}
                </h2>
                <p>{{ 'agreementTerms.payments.p1' | translate }}</p>
            </div>

            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black">
                    {{ 'agreementTerms.refunds.title' | translate }}
                </h2>
                <p>{{ 'agreementTerms.refunds.p1' | translate }}</p>
            </div>

            <div class="space-y-5">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black">
                    {{ 'agreementTerms.privacy.title' | translate }}
                </h2>
                <div class="space-y-5">
                    <p>{{ 'agreementTerms.privacy.p1' | translate }}</p>
                    <p>{{ 'agreementTerms.privacy.p2' | translate }}</p>
                    <p>{{ 'agreementTerms.privacy.p3' | translate }}</p>
                    <p>{{ 'agreementTerms.privacy.p4' | translate }}</p>
                    <p>{{ 'agreementTerms.privacy.p5' | translate }}</p>
                    <p>{{ 'agreementTerms.privacy.p6' | translate }}</p>
                    <p>{{ 'agreementTerms.privacy.p7' | translate }}</p>
                    <p>{{ 'agreementTerms.privacy.p8' | translate }}</p>
                    <p>{{ 'agreementTerms.privacy.p9' | translate }}</p>
                    <p>{{ 'agreementTerms.privacy.p10' | translate }}</p>
                    <p>{{ 'agreementTerms.privacy.p11' | translate }}</p>
                    <p>{{ 'agreementTerms.privacy.p12' | translate }}</p>
                </div>
            </div>

            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black">
                    {{ 'agreementTerms.liability.title' | translate }}
                </h2>
                <p>{{ 'agreementTerms.liability.p1' | translate }}</p>
            </div>

            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black">
                    {{ 'agreementTerms.information.title' | translate }}
                </h2>
                <p>{{ 'agreementTerms.information.p1' | translate }}</p>
            </div>

            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black">
                    {{ 'agreementTerms.indemnity.title' | translate }}
                </h2>
                <p>{{ 'agreementTerms.indemnity.p1' | translate }}</p>
            </div>

            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black">
                    {{ 'agreementTerms.assignment.title' | translate }}
                </h2>
                <p>{{ 'agreementTerms.assignment.p1' | translate }}</p>
            </div>

            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black">
                    {{ 'agreementTerms.changes.title' | translate }}
                </h2>
                <p>{{ 'agreementTerms.changes.p1' | translate }}</p>
            </div>

            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black">
                    {{ 'agreementTerms.jurisdiction.title' | translate }}
                </h2>
                <p>{{ 'agreementTerms.jurisdiction.p1' | translate }}</p>
            </div>
        </div>
    </div>
</section>